import { renaissanceWorks, wideWorks } from "@/mocks/portfolio";
import FadeIn from "@/components/base/FadeIn";
import TiltCard from "@/components/base/TiltCard";

export default function Renaissance() {
  return (
    <section id="renaissance" className="bg-background-50 py-24 md:py-36">
      <div className="px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-14 md:mb-20">
          <div>
            <p className="font-display text-xs uppercase tracking-[0.25em] text-foreground-700 mb-4 title-eyebrow">
              ( 03 ) — Project Series
            </p>
            <h2 className="font-display font-black text-foreground-950 leading-[0.85] tracking-[-0.04em] text-[14vw] md:text-[10vw] lg:text-[9vw] whitespace-nowrap">
              <span className="title-caps">RE:</span>
              <em className="font-serif italic font-light title-italic">Naissance</em>
            </h2>
          </div>
          <div className="max-w-md">
            <p className="text-base md:text-lg text-foreground-700 leading-relaxed font-serif">
              A meditation on rebirth — classical iconography filtered through the lens of generative AI and returned to canvas.
            </p>
          </div>
        </div>

        {/* Tag chips */}
        <div className="flex flex-wrap items-center gap-3 mb-12">
          {["Digital Painting", "Gen AI", "Baroque", "2035"].map((tag, i) => (
            <span
              key={i}
              className="px-4 py-2 rounded-full border border-foreground-950/30 text-foreground-950 text-xs uppercase tracking-[0.18em] font-display"
            >
              {tag}
            </span>
          ))}
        </div>

        {/* 6-grid alternating heights */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6 mb-6 md:mb-8" data-product-shop>
          {renaissanceWorks.map((w, i) => (
            <FadeIn key={i} delay={i * 60} className="group cursor-pointer">
              <TiltCard className={`${w.aspect} bg-background-100 overflow-hidden mb-3`} maxTilt={8} scale={1.02}>
                <img
                  src={w.image}
                  alt={w.id}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 z-10 pointer-events-none">
                  <div className="absolute inset-0 border-[4px] border-accent-500/50" />
                  <div className="absolute inset-[4px] border-[2px] border-accent-500/25" />
                  <div className="absolute top-[4px] left-[4px] w-5 h-5 border-t-[3px] border-l-[3px] border-accent-500" />
                  <div className="absolute top-[4px] right-[4px] w-5 h-5 border-t-[3px] border-r-[3px] border-accent-500" />
                  <div className="absolute bottom-[4px] left-[4px] w-5 h-5 border-b-[3px] border-l-[3px] border-accent-500" />
                  <div className="absolute bottom-[4px] right-[4px] w-5 h-5 border-b-[3px] border-r-[3px] border-accent-500" />
                </div>
              </TiltCard>
              <div className="flex items-center justify-between">
                <span className="font-display text-[11px] md:text-xs uppercase tracking-[0.2em] text-foreground-950">
                  {w.id}
                </span>
                <i className="ri-arrow-right-up-line text-foreground-950 text-base opacity-0 group-hover:opacity-100 transition-opacity"></i>
              </div>
            </FadeIn>
          ))}
        </div>

        {/* Wide images */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6" data-product-shop>
          {wideWorks.map((w, i) => (
            <FadeIn key={i} delay={renaissanceWorks.length * 60 + i * 80} className="group cursor-pointer">
              <TiltCard className="aspect-[4/3] bg-background-100 overflow-hidden mb-3" maxTilt={8} scale={1.02}>
                <img
                  src={w.image}
                  alt={w.id}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 z-10 pointer-events-none">
                  <div className="absolute inset-0 border-[4px] border-accent-500/50" />
                  <div className="absolute inset-[4px] border-[2px] border-accent-500/25" />
                  <div className="absolute top-[4px] left-[4px] w-5 h-5 border-t-[3px] border-l-[3px] border-accent-500" />
                  <div className="absolute top-[4px] right-[4px] w-5 h-5 border-t-[3px] border-r-[3px] border-accent-500" />
                  <div className="absolute bottom-[4px] left-[4px] w-5 h-5 border-b-[3px] border-l-[3px] border-accent-500" />
                  <div className="absolute bottom-[4px] right-[4px] w-5 h-5 border-b-[3px] border-r-[3px] border-accent-500" />
                </div>
              </TiltCard>
              <div className="flex items-center justify-between">
                <span className="font-display text-[11px] md:text-xs uppercase tracking-[0.2em] text-foreground-950">
                  {w.id}
                </span>
                <i className="ri-arrow-right-up-line text-foreground-950 text-base opacity-0 group-hover:opacity-100 transition-opacity"></i>
              </div>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  );
}